var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginShapeGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 405,
    height: 331,
    viewBox: "0 0 405 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0202 84.4992C56.4198 33.9557 70.1588 14.1127 108.104 3.51055C187.25 -18.6056 267.586 69.2808 325.421 113.219C370.089 147.157 419.604 192.007 400.967 254.079C380.008 323.93 282.217 355.175 227.031 309.579C187.459 276.873 172.364 275.65 122.605 301.115C67.3224 329.407 37.447 326.899 12.9966 291.909C-6.32358 264.277 -2.18191 231.099 12.8689 202.917C47.0159 138.972 47.3766 137.89 52.0202 84.4992Z",
    fill: "#D2D2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginShapeGray);
export default __webpack_public_path__ + "static/media/login_shape_gray.69f7ea11673d62b46f4daf07626aaf88.svg";
export { ForwardRef as ReactComponent };